export default {
    configurations: {},
    configuration_promises: [],
    group_configurations: {},
    group_configuration_promises: [],
    preferences: {},
    locales: [],
}
